import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import { API_TIMEOUT_INTERVAL } from '../utils/const'
import { i18n } from '../lang'

function showErrorMessage(message, code) {
  const errorMessage = i18n.te(`error.${message}`)
    ? i18n.t(`error.${message}`)
    : message
  Message({
    message: `${errorMessage} (${code})`,
    type: 'error',
    duration: 5 * 1000,
  })
}

export const adminAPIService = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: API_TIMEOUT_INTERVAL,
})

adminAPIService.interceptors.request.use((config) => {
  const token = store.getters['user/token']
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}, error => Promise.reject(error))

adminAPIService.interceptors.response.use((response) => {
  const res = response.data

  if (typeof res === 'string' || res.code === 200) {
    return response.data
  }
  showErrorMessage(res.type, res.code)
  return Promise.reject(new Error(res.type))

  // Server defined error codes.
  // 508: Invalid token
  // 512: Token being used from other source
  // 514: Expired token
  // if (res.code === 508 || res.code === 512 || res.code === 514) {
  //   MessageBox.confirm('You have been logged out. You can choose to stay on the page or login again.', 'Confirm Logout', {
  //     confirmButtonText: 'Login Again',
  //     cancelButtonText: 'Cancel',
  //     type: 'warning'
  //   }).then(() => {
  //     store.dispatch('logout').then(() => {
  //       router.push({ path: '/login' })
  //     })
  //   })
  // } else {
  //   console.log(response)
  //   showErrorMessage(res.message, res.code)
  // }
}, (error) => {
  showErrorMessage(error.message, error.code)
  return Promise.reject(error)
})

export const adminFileDownloadService = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: API_TIMEOUT_INTERVAL,
})

adminFileDownloadService.interceptors.request.use((config) => {
  const token = store.getters['user/token']
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}, error => Promise.reject(error))

export const vaderAPIService = axios.create({
  baseURL: process.env.VUE_APP_VADER_API_BASE_URL,
  timeout: API_TIMEOUT_INTERVAL,
})

export const goxipAPIService = axios.create({
  baseURL: process.env.VUE_APP_GOXIP_APP_API_BASE_URL,
  timeout: API_TIMEOUT_INTERVAL,
})

goxipAPIService.interceptors.request.use((config) => {
  const token = store.getters['user/token']
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}, error => Promise.reject(error))

export const newhopeAPIService = axios.create({
  baseURL: 'https://www.goxip.com/vader/ap2/api/v1/newhope',
  timeout: API_TIMEOUT_INTERVAL,
})
newhopeAPIService.interceptors.request.use((config) => {
  const token = store.getters['user/token']
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
}, error => Promise.reject(error))

newhopeAPIService.interceptors.response.use((response) => {
  const res = response.data

  if (typeof res === 'string' || res.code === 200) {
    return response.data
  }

  showErrorMessage(res.type, res.code)
  return Promise.reject(new Error(res.type))
}, (error) => {
  showErrorMessage(error.message, error.code)
  return Promise.reject(error)
})
